export var REPORTS_PATH;
(function (REPORTS_PATH) {
    REPORTS_PATH["ITEM_SALES_REPORT_AP"] = "/qc/reports/ap/itemsales";
    REPORTS_PATH["ITEM_SALES_REPORT_PC"] = "/qc/reports/pc/itemsales";
    REPORTS_PATH["DAILY_SALES_REPORT_BY_STALL"] = "/qc/reports/dailysalesentry/stall";
})(REPORTS_PATH || (REPORTS_PATH = {}));
